var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnalyticsActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1871 2.66248C11.7591 2.66248 11.4121 3.00945 11.4121 3.43748V6.41248H7.81211C7.38409 6.41248 7.03711 6.75946 7.03711 7.18748V10.1625H3.43711C3.00909 10.1625 2.66211 10.5095 2.66211 10.9375V15.7875H2.18711C1.75909 15.7875 1.41211 16.1345 1.41211 16.5625C1.41211 16.9905 1.75909 17.3375 2.18711 17.3375L3.43711 17.3375L17.8121 17.3375C18.2401 17.3375 18.5871 16.9905 18.5871 16.5625C18.5871 16.1345 18.2401 15.7875 17.8121 15.7875H17.3371V3.43748C17.3371 3.00945 16.9901 2.66248 16.5621 2.66248H12.1871ZM11.4121 15.7875V7.96248H8.58711V15.7875H11.4121ZM4.21211 11.7125H7.03711V15.7875H4.21211V11.7125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyticsActive);
export default __webpack_public_path__ + "static/media/analytics-active.ae27af4b5895b8d6e0450bf3c8b86750.svg";
export { ForwardRef as ReactComponent };